import { memo, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../../components/ui/dropdown-menu.js";
import SvgIcon from "../../../../components/SvgIcon";
import useNodesInteractions from "../../hooks/use-nodes-interactions";

const NodeControl = ({ id, selected }) => {
  const { handleSelectNode, duplicateNode, deleteNode } =
    useNodesInteractions();

  const [open, setOpen] = useState(false);

  //   useEffect(() => {
  //     if (!selected) setOpen(false);
  //   }, [selected]);

  return (
    <div
      className={`
      invisible group-hover:visible
      ${selected && "visible"}
      ${open && "visible"}
      `}
      onClick={(e) => e.stopPropagation()}
    >
      <DropdownMenu open={open} onOpenChange={(open) => setOpen(open)}>
        <DropdownMenuTrigger onClick={() => handleSelectNode(id)}>
          <SvgIcon name="proicons:more" className="cursor-pointer" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem onClick={() => duplicateNode(id)}>
            <SvgIcon name="famicons:copy-outline" className="" />
            <span>Duplicate</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => deleteNode(id)}>
            <SvgIcon
              name="material-symbols-light:delete-outline"
              className="text-red-500"
            />
            <span className="text-red-500">Delete</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default memo(NodeControl);
